
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Box, Divider, Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";

const ArcBanner = (props) => {
    // ChartJS.register(ArcElement, Tooltip, Legend);
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, MaxValue, Label, Color, Proportion } = ComponentProperties
    const DataReportData = props.DataReportData
    // KeyToUse will be an array

    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}>
            <Grid item xs={12}>
                <Box pt={3}>
                    <Typography variant="h3" align="center">{Label}</Typography>
                </Box>
                <Divider/>
            </Grid>
        </Grid>
    )
}

export default ArcBanner